/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Outlet, Link, useNavigate, useLocation, useParams, useSearchParams} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {LoadingComponent} from './LoadingComponent'
import {useAuth} from './core/Auth'
import {getUserByToken, singleSignOn} from './core/_requests'
import toaster from '../../../utils/toaster'
import {useDataLayerValue} from '../../../DataLayer'

const AuthLayout = () => {
  const {currentUser, setCurrentUser, saveAuth} = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [{company}, dispatch] = useDataLayerValue()

  const params = new URLSearchParams(location.search)
  const token = params.get('access_token')

  const [isRedirecting, setIsRedirecting] = useState<boolean>(false)

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  useEffect(() => {
    if (location) {
      if (token) {
        handleSingleSignOn(token)
      }
    }
  }, [location])

  const handleSingleSignOn = async (token: string) => {
    setIsRedirecting(true)
    try {
      const {data: auth} = await singleSignOn(token)
      if (auth.isAuthenticated === false) {
        toaster('error', auth.message)
      } else {
        if ([22.1, 22.2].some((number) => JSON.parse(auth?.policies)?.includes(number))) {
          dispatch({
            type: 'SET_POLICIES',
            policies: JSON.parse(auth?.policies),
          })
          saveAuth(auth)
          const {data: user} = await getUserByToken()
          toaster('success', 'Login successful')
          setCurrentUser(user)
        } else {
          toaster('error', 'unauthorized')
        }
      }
    } catch (error) {
      console.error(error)
      saveAuth(undefined)
    } finally {
      setIsRedirecting(false)
    }
  }

  return (
    <div
      className='d-flex flex-column h-100 w-100 no-repeat bg-size-cover bg-position-center'
      style={{
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundImage: `url(${toAbsoluteUrl('/media/other/bg3.jpg')})`,
      }}
    >
      {/* begin::Body */}

      {/* begin::Form */}
      <div className='d-flex flex-center flex-column flex-lg-row-fluid h-100 align-items-center'>
        {/* begin::Wrapper */}
        <div className='w-lg-500px p-10 card' style={{backgroundColor: 'rgba(255, 255, 255, .8)'}}>
          <img
            className='mx-auto  '
            src={toAbsoluteUrl('/media/logos/auth-screens2.png')}
            alt=''
            style={{width: '180px'}}
          />
          <div className='separator mb-10 mt-8'></div>

          <Outlet />
          {isRedirecting && <LoadingComponent isRedirecting={isRedirecting} />}
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Form */}
    </div>
  )
}

export {AuthLayout}
